/* global jQuery, dataLayer, mcGlobal */
(function ($) {
	$('document').ready(function () {
		const isListing = !!(mcGlobal && mcGlobal.isSingle);

		if (isListing) {
			addTrackingForSingleListing();
		} else {
			// Not a single listing, so probably either home or search with listings.
			const listings = $('.search-listing-container .search-listing');
			if (!listings) {
				return;
			}
			addTrackingForListOfListings(listings);
		}
	});

	/**
	 * Add click and impression tracking for single listing template.
	 */
	function addTrackingForSingleListing() {
		const categoryType = 'Listing Page';
		const dirName = `${mcGlobal.directoryName} | `;
		const listing = $('.listing-profile');
		const listingType = listing.hasClass('listing-profile-enhanced') ? ' | EDL' : ' | BASIC';
		const name = dirName + listing.find('.listing-profile__title').text().trim() + listingType;

		$('.listing-profile-sidebar__telephone-link').click(function () {
			sendClickEvent(categoryType, 'mobile click to call', name);
		});

		$('.listing-profile-sidebar__practice-contact-links-list-link.-visit-website').click(
			function () {
				sendClickEvent(categoryType, 'website', name);
			},
		);

		$('.listing-profile-sidebar__practice-contact-links-list-link.-request-appointment').click(
			function () {
				sendClickEvent(categoryType, 'request appointment', name);
			},
		);

		$('.listing-profile-sidebar__practice-contact-links-list-link.-contact-button').click(
			function () {
				sendClickEvent(categoryType, 'contact button', name);
			},
		);

		$('.listing-profile-sidebar__social-item a').click(function () {
			sendClickEvent(categoryType, 'social icon', name);
		});

		$('.listing-profile-sidebar__claim-listing').click(function () {
			sendClickEvent(categoryType, 'claim listing', name);
		});

		sendImpressionEvent(categoryType, name);
	}

	/**
	 * Add click and impression tracking for home, search, and categories.
	 *
	 * @param {Array} $listings jQuery list of listing elements.
	 */
	function addTrackingForListOfListings($listings) {
		if (!$listings) {
			return;
		}

		const dirName = `${mcGlobal.directoryName} | `;
		$.each($listings, function () {
			// Each listing has a click event added and has an individual
			// impression event sent for each listing shown in the results.
			const categoryType = 'Search results';
			const listingType = $(this).hasClass('search-listing-enhanced') ? ' | EDL' : ' | BASIC';
			const name =
				dirName + $(this).find('.search-listing__title-link').text().trim() + listingType;

			$(this)
				.find('.search-listing__title-link, .search-listing__image-link')
				.click(function () {
					sendClickEvent(categoryType, '', name);
				});

			sendImpressionEvent(categoryType, name);
		});
	}

	/**
	 * Push click event to GTMdataLayer.
	 *
	 * @param {string} category Name of the category.
	 * @param {string} label    (optional) Label for event.
	 * @param {string} name     Name to use in event label.
	 */
	function sendClickEvent(category, label, name) {
		const sendLabel = label === '' ? name : `${name}, ${label}`;
		dataLayer.push({
			event: 'DirectoryCustomEvents',
			EventAction: 'Click',
			EventCategory: category,
			EventLabel: sendLabel,
		});
	}

	/**
	 * Push an impression event to the GTM dataLayer.
	 *
	 * @param {string} category Name of the category.
	 * @param {string} label    Label of event.
	 */
	function sendImpressionEvent(category, label) {
		dataLayer.push({
			event: 'DirectoryCustomEvents',
			EventAction: 'Impression',
			EventCategory: category,
			EventLabel: label,
		});
	}
})(jQuery);
